


























import {
  defineComponent,
  PropType,
  ref,
  useContext,
  computed,
} from "@nuxtjs/composition-api";
import { useUiHelpers } from "@wemade-vsf/composables";
import FilterBox from "components/catalog/Category/Filters/Renderer/FilterBox.vue";
import { SfButton, SfLink, SfList } from "@storefront-ui/vue";
import { Category } from "@wemade-vsf/catalog/lib/runtime/category/types";

export default defineComponent({
  components: {
    FilterBox,
    SfLink,
    SfList,
    SfButton,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    categories: {
      type: Array as PropType<Category[]>,
      default: () => [],
    },
    open: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { localePath } = useContext();
    const { getCatLink } = useUiHelpers();

    const getCategoryLink = (category) => {
      return decodeURIComponent(localePath(getCatLink(category)));
    };

    const hasMore = computed(() => props.categories.length > 10);
    const showMore = ref(false);
    const filteredCategories = computed(() => {
      if (!hasMore.value) return props.categories;
      const categories = props.categories;
      return showMore.value ? categories : categories.slice(0, 10);
    });

    return {
      getCategoryLink,
      hasMore,
      showMore,
      filteredCategories,
    };
  },
});
